export const formatDateString = (dateString: string): string => {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  // Split input into date and time components
  const [datePart, timePart] = dateString.split(' ');
  const [day, month, year] = datePart.split('-').map(Number);
  const [hour, minute] = timePart.split(':').map(Number);

  // Create a Date object
  const date = new Date(year, month - 1, day, hour, minute);

  // Format parts
  const formattedDay = String(date.getDate()).padStart(2, '0');
  const formattedMonth = months[date.getMonth()];
  const formattedYear = date.getFullYear();

  // Handle 12-hour format and period
  const period = date.getHours() >= 12 ? 'P.M.' : 'A.M.';
  const formattedHour = date.getHours() % 12 || 12; // Convert 0 to 12 for 12-hour format
  const formattedMinute = String(date.getMinutes()).padStart(2, '0');

  return `${formattedDay} ${formattedMonth} ${formattedYear} ${formattedHour}:${formattedMinute} ${period}`;
};

// Test

export const formatApiDateToDisplay = (dateString: string): string => {
  if (!dateString || dateString === '-') return '-';
  try {
    // Parse ISO 8601 date (e.g., "2025-09-02T10:11:02.033870Z")
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return '-';
    }
    const dayOfMonth = date.getDate();
    const monthName = date.toLocaleString('en-US', { month: 'short' });
    const fullYear = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12; // Convert to 12-hour format
    const formattedMinutes = minutes.toString().padStart(2, '0');
    return `${monthName} ${dayOfMonth}, ${fullYear}, ${formattedHours}:${formattedMinutes} ${ampm}`;
  } catch {
    return '-';
  }
};
